import { useGetManagedEmployerQuery } from "@js/apps/employer/hooks/get-managed-employer";

export const useEmployerCompanyNode = () => {
  const { data: employerProfile } = useGetManagedEmployerQuery();

  return employerProfile?.company_node ?? null;
};
